import { useCustomText } from "@babackapp/return-widget-components/hooks/use-custom-text";
import type { ReturnRequestShippingInfoDto, ShopReturnToStoreStoresDto } from "@babackapp/private-api-client";
import { motion } from "motion/react";

type Props = {
  shippingInfo: ReturnRequestShippingInfoDto;
  returnStore?: ShopReturnToStoreStoresDto;
};

export function ReturnMethodSection({ shippingInfo, returnStore }: Props) {
  const t = useCustomText();

  const carrierName = shippingInfo.carrierTitle ?? shippingInfo.carrier;
  const isStoreReturn = !!shippingInfo.returnStoreId;

  if (!carrierName && !isStoreReturn) return null;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3, delay: 0.1 }}
      className="flex flex-col gap-2 px-1"
    >
      <p className="text-sm font-medium text-foreground">
        {t("returnMode.title")}
      </p>
      <div className="flex flex-col gap-1">
        {isStoreReturn ? (
          <div className="flex flex-col gap-0.5">
            <p className="text-sm text-muted-foreground">
              {returnStore?.name ?? t("returnRequests.details.returnMethod.store")}
            </p>
            {returnStore?.address && (
              <p className="text-xs text-muted-foreground/70">
                {returnStore.address.address1}
                {returnStore.address.address2 ? `, ${returnStore.address.address2}` : ""}
                {` — ${returnStore.address.city}`}
              </p>
            )}
          </div>
        ) : (
          <>
            {carrierName && (
              <p className="text-sm text-muted-foreground">{carrierName}</p>
            )}
          </>
        )}
      </div>
    </motion.div>
  );
}
